import React from 'react';
import ConditionBuilder from '../../../components/common/ConditionBuilder';
import Select from '../../../components/ui/Select';
import { CONDITION_OPTIONS } from '../../../constants/segmentConstants';
import { Condition } from '../../../types/segments/segments.types';

interface SettingsStepProps {
  filters: { [key: string]: Condition[] };
  setFilters: (conditions: { [key: string]: Condition[] }) => void;
  campaignStatus?: 'draft' | 'live' | 'paused' | 'archived';
}

const SettingsStep: React.FC<SettingsStepProps> = ({
  filters,
  setFilters,
  campaignStatus,
}) => {
  const frequencyOptions = [
    { value: 'daily', label: 'Daily' },
    { value: 'weekly', label: 'Weekly' },
    { value: 'monthly', label: 'Monthly' },
  ];

  return (
    <div className="flex h-[calc(90vh-40px)]">
      {/* Main Content Area */}
      <div className="flex-1 overflow-y-auto bg-background">
        <div className="max-w-6xl mx-auto p-6">
          {campaignStatus === 'live' && (
            <div className="bg-warning-background rounded-lg border border-warning/30 px-4 py-3 flex items-center gap-3 mb-3">
              <div className="relative flex items-center justify-center flex-shrink-0">
                <div className="absolute w-3 h-3 bg-warning rounded-full animate-pulse opacity-75"></div>
                <div className="relative w-3 h-3 bg-warning rounded-full"></div>
              </div>
              <div className="text-sm font-medium text-warning-foreground">
                After any changes, you need to save the campaign to make it
                live.
              </div>
            </div>
          )}
          <div className="bg-card rounded-lg border border-border p-6">
            {/* Filters Title Container */}
            <div className="mb-6">
              <h2 className="text-xl font-semibold text-foreground">Filters</h2>
              <p className="text-sm text-muted-foreground mt-1">
                Apply filters to refine your campaign audience:
              </p>
            </div>

            <ConditionBuilder
              applyMaxHeight={false}
              conditions={filters}
              onConditionsChange={setFilters}
              dataSourceOptions={CONDITION_OPTIONS}
            />

            {/* Frequency Dropdown */}
            <div className="mt-6">
              <Select
                label="Frequency"
                placeholder="Select frequency"
                options={frequencyOptions}
                disabled={true}
                value=""
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SettingsStep;
